import clientAuth from "../clientAuth";

export default {
    index: () => clientAuth.get("banner/index"),

    update: (userData) => clientAuth.post('banner/update', { json: userData }),

};